module.exports = __webpack_public_path__ + "static/img/一键报税.2e8bbe0e.png";